import { Anchor, LoadingOverlay } from '@mantine/core';
import { useEffect, useState } from 'react';

import useUserInvoiceDetails, {
  UserInvoice,
} from '@/api/useUserInvoiceDetails';
import { useCheckoutStore } from '@/store/checkout';

import { AddEditAddressModal } from './components/AddEditAddressModal';
import { InvoiceInformation } from './components/InvoiceInformation';

export const Invoice = () => {
  const { userInvoiceInfo, isLoading } = useUserInvoiceDetails();
  const { setHasInvoiceData } = useCheckoutStore();
  const [isAddEditModalOpened, setIsAddEditModalOpened] = useState(false);

  const handleOnClick = () => {
    setIsAddEditModalOpened(true);
  };

  useEffect(() => {
    if (isLoading) return;
    setHasInvoiceData(!!userInvoiceInfo?.nif);
  }, [isLoading, setHasInvoiceData, userInvoiceInfo?.nif]);

  if (isLoading) return <LoadingOverlay visible={isLoading}></LoadingOverlay>;

  if (!userInvoiceInfo?.nif) {
    return (
      <div>
        Antes de efetuar uma compra, deverá adicionar os dados de faturação e
        uma morada de envio{' '}
        <Anchor onClick={handleOnClick} color="green">
          aqui.
        </Anchor>
        <AddEditAddressModal
          title={'Adicionar novo endereço'}
          isOpened={isAddEditModalOpened}
          onClose={() => setIsAddEditModalOpened(false)}
          onConfirm={() => setIsAddEditModalOpened(false)}
          addressId={undefined}
        />
      </div>
    );
  }

  return (
    <InvoiceInformation userInvoiceInfo={userInvoiceInfo as UserInvoice} />
  );
};
